export default "__VITE_ASSET__D7q0newQ__"